<div class="aisearch-result-container" [class.hidden]="notFound"> 
</div>
    <div class="result" [class.hidden]="notFound">
        <div class="data-container">
            <div class="description-container">
                <p style="font-size: 18px; font-family: 'IBM Plex Sans Thai';" [innerHTML]="streamDataStr"></p>
            </div>
        </div>
        <div class="corner-icon" style="display: flex;">
            <div style="display: flex; position: relative; width: fit-content; height: fit-content;">
                <img src="assets/navbar-component-images/banner.svg" alt="banner.svg" >
                <img src="assets/navbar-component-images/bannerVector.svg" alt="bannerVector.svg" style="position: absolute; left: 35%; top: 17%;">
            </div>
        </div>         
    </div>